import { render, staticRenderFns } from "./IDN.vue?vue&type=template&id=1e5f624a&scoped=true&"
import script from "./IDN.vue?vue&type=script&lang=js&"
export * from "./IDN.vue?vue&type=script&lang=js&"
import style0 from "./IDN.vue?vue&type=style&index=0&id=1e5f624a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e5f624a",
  null
  
)

export default component.exports